import { call, put, takeEvery, select } from 'redux-saga/effects'

// @ts-ignore
import { showError } from 'store/entities/toastr/utils'
import { uploadFileToS3 } from 'store/entities/api/sagas/s3PolicySagas'
// @ts-ignore
import { addImageToGallery, updateImageUsagePlaces } from 'store/entities/gallery/actions'
// @ts-ignore
import { uploadActivityImage, updateActivityImage } from 'store/entities/protracks/activities/actions.js'
import { IHandleUploadActivitiesImageRequest } from 'store/entities/protracks/activities/sagas/interfaces'
import { IParams } from 'store/entities/api/sagas/interfaces'
// @ts-ignore
import { getActivitiesWithImageLinkInvalid } from 'store/entities/protracks/activities/selectors'
// @ts-ignore
import { getViewProtrack } from 'store/entities/protracks/selectors'
// @ts-ignore
import { getActivityNameForUsagePlaces } from 'helpers/getActivityNameForUsagePlaces.ts'
// @ts-ignore
import { promisedCanvasToBlob } from 'helpers/promises/promisedCanvasToBlob'
import imageNameNormalizer from 'helpers/imageNameNormalizer'

export default function* uploadActivitiesImageSaga() {
  yield takeEvery(uploadActivityImage, handleUploadActivitiesImageRequest)
}

export function* handleUploadActivitiesImageRequest({ payload }: IHandleUploadActivitiesImageRequest) {
  const { file, fileResolution, imageDomainId, s3Entity, mime, canvasFileName } = payload
  try {
    const isConfirmRewriteImage = false // for correct save on back end
    let imagePath = ''
    let fileName = ''
    // file  will be instanceof HTMLCanvasElement when image was cropped before upload
    if (file instanceof HTMLCanvasElement && !!canvasFileName) {
      const blob = yield call(promisedCanvasToBlob, file, mime)
      const ext = canvasFileName.split('.')[1]
      fileName = imageNameNormalizer(canvasFileName)
      imagePath = yield call(uploadActivitiesImageToS3, blob, ext, s3Entity, {
        fileName,
        fileResolution,
        isConfirmRewriteImage,
        imageDomainId,
      })
    } else {
      const ext = file.name.split('.')[1]
      fileName = imageNameNormalizer(file.name)
      imagePath = yield call(uploadActivitiesImageToS3, file, ext, s3Entity, {
        fileName,
        fileResolution,
        isConfirmRewriteImage,
        imageDomainId,
      })
    }
    const activitiesWithInvalidImageLink = yield select(getActivitiesWithImageLinkInvalid)
    const activitiesWithExistFileName = activitiesWithInvalidImageLink.find(
      (activity: Map<string, any>) => activity.get('image') === fileName
    )
    if (activitiesWithExistFileName === undefined) {
      yield put(addImageToGallery(imagePath, isConfirmRewriteImage))
    } else {
      let usagePlaces = ''
      const activities = activitiesWithInvalidImageLink.toJS()
      const viewProtrackName = (yield select(getViewProtrack)).get('name')
      usagePlaces += `______${viewProtrackName}___`
      for (const activity in activities) {
        if (activities[activity].image === fileName) {
          yield put(updateActivityImage(activities[activity].id, imagePath))
          // @ts-ignore
          usagePlaces = getActivityNameForUsagePlaces(activities[activity].name, usagePlaces)
        }
      }
      yield put(addImageToGallery(imagePath, isConfirmRewriteImage))
      yield put(updateImageUsagePlaces(imagePath, usagePlaces))
    }
  } catch (badResponse) {
    showError()
  }
}

export function* uploadActivitiesImageToS3(file: File, ext: string, s3Entity: string, params: IParams) {
  return yield call(uploadFileToS3, { file, ext, entity: s3Entity, params })
}
